import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function AdvisorMessage({ 
  accent = "#115e32",
  pageTitle = "Cheif Advisor Message | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]">
      {/* Hero Section with SVG */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE]">
        {/* SVG Decorative Background */}
        <div className="absolute inset-0 flex justify-center items-center opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="650"
            height="650"
            viewBox="0 0 650 650"
            fill="none"
            className="animate-spin-slow"
          >
            <circle
              cx="325"
              cy="325"
              r="280"
              stroke="#d4af37"
              strokeWidth="3"
              strokeDasharray="12 12"
            />
            <circle
              cx="325"
              cy="325"
              r="180"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="8 8"
            />
          </svg>
        </div>

        <div className="relative container mx-auto px-6 py-20 text-center">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-800"
          >
            Message from the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#2563eb]">
              Cheif Advisor
            </span>
          </motion.h1>
        </div>
      </section>

      {/* VC Message Section */}
      <section className="relative container mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        {/* VC Picture */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center"
        >
          
        </motion.div>

        {/* VC Message */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6 text-gray-700"
        >
         
        </motion.div>
      </section>
    </div>
  );
}
